<!-- TODO: use https://github.com/Gbuomprisco/ngx-chips to add tags-->

<div class="row mb-2" *ngIf="isSuperAdmin && finderData &&  finderData.admin">
  <app-new-tchek></app-new-tchek>

  <!-- classificationImages -->
  <div class="col-4" style="max-width: 210px;">
    <button (click)='goToClassificationImages()' type="button" class="btn btn-lg primary longSubmit"
      i18n="newTchek|@@imageclassification">Classification Images</button>
  </div>

  <!-- inspect all list  -->
  <div class="col-4" style="max-width: 155px;">
    <button (click)='inspectList()' type="button" class="btn btn-lg primary longSubmit"
      i18n="newTchek|@@inspectlist">Détection Alto</button>
  </div>

  <app-classification></app-classification>
  <app-finder-admin (changeAdminData)="updateSearchTagsAdmin($event)"></app-finder-admin>
</div>

<div class="row" *ngIf="finderData">
  <div class="col-12 col-lg-5">
    <div id="search-wrapper">
      <!-- <input type="text" id="search-input" placeholder="Immatriculation, marque ou modèle" (focus)="focusInput(true)" (blur)="focusInput(false)" [ngModel]="searchText" (ngModelChange)="updateSearchText($event)"> -->
      <tag-input id="search-input" placeholder="Immatriculation..." 
        (focus)="focusInput(true)" (blur)="focusInput(false)" [ngModel]="finderData.searchTags"
        [placeholder]="placeHolderImmatSearch" [secondaryPlaceholder]="placeHolderImmatSearch"
        (ngModelChange)="updateSearchTags($event)"></tag-input>
      <svg class="search-icon" width="16px" height="17px" viewBox="0 0 16 17" version="1.1"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Shape</title>
        <desc>Created with Sketch.</desc>
        <g id="Page-1" stroke="none" stroke-width="1">
          <g id="UI-Dashboard-+-Calendar-02" transform="translate(-577.000000, -169.000000)">
            <g id="Search" transform="translate(164.000000, 155.000000)">
              <path
                d="M425.7,25.3 C426.6,24.1 427.1,22.7 427.1,21.1 C427.1,17.2 424,14 420.1,14 C416.2,14 413,17.2 413,21.1 C413,25 416.2,28.2 420.1,28.2 C421.7,28.2 423.2,27.7 424.3,26.8 L427.3,29.8 C427.5,30 427.8,30.1 428,30.1 C428.2,30.1 428.5,30 428.7,29.8 C429.1,29.4 429.1,28.8 428.7,28.4 L425.7,25.3 Z M420.1,26.1 C417.3,26.1 415,23.9 415,21.1 C415,18.3 417.3,16 420.1,16 C422.9,16 425.2,18.3 425.2,21.1 C425.2,23.9 422.9,26.1 420.1,26.1 Z"
                id="Shape"></path>
            </g>
          </g>
        </g>
      </svg>
    </div>
  </div>

  <div class="col-12 col-lg-3">
    <div id="datepicker-wrapper">

      <input autocomplete="off" type="text" matInput ngxDaterangepickerMd
        [locale]="{applyLabel: 'ok', format: 'DD-MM-YYYY'}" startKey="start" endKey="end" [(ngModel)]="finderData.date"
        name="daterange" id="daterange" [ranges]="ranges" alwaysShowCalendars="true"
        (ngModelChange)="updateSearchDate($event)" placeholder="Aujourd'hui..."
        i18n-placeholder="finder|@@date_today" />

      <ng-container *ngIf="finderData.isDateActive; else elseTemplate">
        <svg class="calendar-icon" width="16px" height="16px" viewBox="0 0 16 16" (click)="erasedate()" version="1.1"
          xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
          <title>clear</title>
          <desc>Created with Sketch.</desc>
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="UI-Rapport-Tablet-Scroll" transform="translate(-747.000000, -347.000000)" fill="#E3E3E3"
              fill-rule="nonzero">
              <g id="Content" transform="translate(12.000000, -101.000000)">
                <g id="01" transform="translate(20.000000, 80.000000)">
                  <g id="Section" transform="translate(0.000000, 326.000000)">
                    <g id="Group-9" transform="translate(1.000000, 35.000000)">
                      <path
                        d="M722,7 C717.6,7 714,10.6 714,15 C714,19.4 717.6,23 722,23 C726.4,23 730,19.4 730,15 C730,10.6 726.4,7 722,7 Z M725.5,17.1 L724.1,18.5 L722,16.4 L719.9,18.5 L718.5,17.1 L720.6,15 L718.5,12.9 L719.9,11.5 L722,13.6 L724.1,11.5 L725.5,12.9 L723.4,15 L725.5,17.1 Z"
                        id="Shape"></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </ng-container>
      <ng-template #elseTemplate>
        <svg class="calendar-icon" width="16px" height="16px" viewBox="0 0 16 16" version="1.1"
          xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->
          <title>calendar-date-2</title>
          <desc>Created with Sketch.</desc>
          <g id="Page-1" stroke="none" stroke-width="1">
            <g id="UI-Dashboard-+-Calendar-02" transform="translate(-842.000000, -169.000000)">
              <g id="Calendar" transform="translate(625.000000, 155.000000)">
                <g id="calendar-date-2" transform="translate(217.000000, 14.000000)">
                  <path
                    d="M15,2 L13,2 L13,0 L10,0 L10,2 L6,2 L6,0 L3,0 L3,2 L1,2 C0.448,2 0,2.448 0,3 L0,15 C0,15.552 0.448,16 1,16 L15,16 C15.552,16 16,15.552 16,15 L16,3 C16,2.448 15.552,2 15,2 Z M14,14 L2,14 L2,5 L14,5 L14,14 Z"
                    id="Shape"></path>
                  <rect id="Rectangle" x="4" y="7" width="2" height="2"></rect>
                  <rect id="Rectangle" x="7" y="7" width="2" height="2"></rect>
                  <rect id="Rectangle" x="4" y="10" width="2" height="2"></rect>
                  <rect id="Rectangle" x="7" y="10" width="2" height="2"></rect>
                  <rect id="Rectangle" x="10" y="7" width="2" height="2"></rect>
                  <rect id="Rectangle" x="10" y="10" width="2" height="2"></rect>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </ng-template>

    </div>
  </div>
  <div class="col-6 col-lg-2">
    <ng-select [items]="statuses" [bindLabel]="'value'" [bindValue]="'key'" [(ngModel)]="finderData.statusSelect"
      [virtualScroll]='true' (change)="onChangeStatus($event)" notFoundText="---" [clearable]='true'
      [searchable]='false' placeholder='Tous' i18n-placeholder="finder|@@All">
    </ng-select>
  </div>
  <div class="col-6 col-lg-2" *ngIf="(this.devicesSelector && this.devicesSelector.length > 1 ) || isSuperAdmin">
    <ng-container *ngIf="deviceLoader
    ; else elseTemplate">
      <content-loader [primaryOpacity]="1" [secondaryOpacity]="0.8" [width]="50" [height]="15">
        <svg:rect id="rect3686" width="50px" height="15px" x="0" y="0" rx="3" ry="3"
          style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
      </content-loader>
    </ng-container>
    <ng-template #elseTemplate>
      <ng-select [items]="devicesSelector" [bindLabel]="'name'" [bindValue]="'id'" [(ngModel)]="finderData.deviceSelect"
        [virtualScroll]='true' (change)="onChangeDevice($event)" notFoundText="---" [clearable]='true'
        [searchable]='true' placeholder='Tous Les Scanners' i18n-placeholder="finder|@@AllScaners">
      </ng-select>
    </ng-template>
  </div>

</div>


<div class="row mt-1" [hidden]="finderData?.activeFilters.length < 1" *ngIf="finderData?.activeFilters">
  <div class="col-sm-12" id="search-pill-container"></div>
</div>

<!-- Base model for filter pills-->
<div class="search-pill" id="search-pill-base" hidden>
  <span class="no-selection pill-value"></span>
  <span aria-hidden="true" class="remove-pill">&times;</span>
</div>


// WEBPACK FOOTER //
// ./src/app/element/finder/finder.component.html